import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import '../styles/css/pro.notes.css';
import WeekTable from '../components/Note.WeekTable';
import QuizTable from '../components/Note.QuizTable';
import { getQuizResult } from '../actions/ProAction';
import {getWeeks} from '../actions/DashboardAction';
import Spinner from '../components/Spinner';
import { sortQuiz2, createSoundState, jsUcfirst } from '../util/utils';
import {pageView, trackEvent} from '../util/tracking';

class WrongNotes extends React.Component{

  constructor(props){
    super(props);
    this.state={
      status : [],              // for closing and opening dropdown in table
      week : null,
      displayedQuiz : null,
      selectedDiv : null,
      day : null,
      prevClickedWeek : null,      // feel like there would be better way to acheive this
      spinner: false
    };
  }
  /*
    getWeeks inj Dashboard action if global state.weeks is not available
    using that weeks create the week table with week title, days, and
    callback function with week id
    get quiz result of certain week using and

    go through analyzing the response ( group up with the same type )
  */
  componentWillMount(){

    let {weeks, courseId} = this.props;

    if(weeks.length === 0){
      this.setState({spinner: true})
      this.props.getWeeks(courseId);
    }
    pageView();
  }

  componentWillReceiveProps(nextProps){
    if(this.props.weeks.length===0){
      this.setState({
        status : Array(nextProps.weeks.length).fill(false)
      });
    }

    if(this.props.weeks!==nextProps.weeks){
      this.setState({spinner: false})
    }
    if(this.props.quizResult !== nextProps.quizResult){
      this.setState({quizResult: nextProps.quizResult});
    }
  }

  show(index, event){
    let {status, week, prevClickedWeek} = this.state;
    let weekId = this.props.weeks[index].id;
    let {courseId, getQuizResult} = this.props;

    // the week table has been already clicked
    if(week !== null){
      status[week] = false;
      if(this.state.selectedDiv !== null){
        this.state.selectedDiv.classList.remove('selected');
      }
      if(week !== index){  // the clicked week is not same as previously clicked week
        // this.setState({spinner:true});
        this.setState({quizResult:null})
        getQuizResult(weekId, courseId);
        status[index] = true;
        week = index;
      } else{  // the clicked week is same as previously clicked week
        week = null;
        prevClickedWeek = index;
      }
      this.setState({
        status,
        week,
        selectedDiv: null,
        prevClickedWeek
      });
    } else{  // week table has not been clicked yet
      if(prevClickedWeek !== index){
        // this.setState({spinner:true});
        getQuizResult(weekId, courseId);
      }
      status[index] = true;
      this.setState({
        status,
        week: index
      });
    }
  }

  onAudioPlay(i, j, evt){
    // can change the icon here (probably just display)
    let tmpSound = [...this.state.sound];

    if(evt.currentTarget.name==='question'){
      tmpSound[i].question = 'PLAYING';
      tmpSound[i].choices = Array(tmpSound[i].choices.length).fill('STOPPED');
    }else if(evt.currentTarget.name==='material'){
      tmpSound[i].material = 'PLAYING';
      tmpSound[i].choices = Array(tmpSound[i].choices.length).fill('STOPPED');
    }else{    // one of choices audio file
      tmpSound[i].question = 'STOPPED';
      tmpSound[i].choices = Array(tmpSound[i].choices.length).fill('STOPPED');
      tmpSound[i].choices[j] = 'PLAYING';

    }

    this.setState({
      sound : tmpSound
    })
  }

  onAudioEnd(evt){
    this.setState({
      sound: [...this.state.default_sound]
    })
  }

  quizDayClicked(type, event){
    if(this.state.selectedDiv !== null){
      this.state.selectedDiv.classList.remove('selected');
    }
    event.currentTarget.classList.add('selected');

    let quizLog = this.props.quizResult.filter(val=>val.study_type===type)
    let date;

    if(quizLog.length>0){
      date = quizLog[0].date;
    }

    let quizTableData;
    let sets = []
    if(type === 'quiz'){
      if(quizLog.length>0){
        sets = sortQuiz2(...quizLog);
        let sound_array = createSoundState(sets);
        this.setState({
          sound: sound_array,
          default_sound: sound_array
        })
      }
      quizTableData = {week:this.state.week, type: type, sets: sets, date: date}
      trackEvent("PREMIUM-AI", "Wrong Answer Notes - Click Quiz", "");

    }else{
      // 이 부분 바꾸기 오답노트 형식이 바뀌면
      if(quizLog.length>0){
        sets = quizLog[0].logs;
      }

      quizTableData = { week: this.state.week, type: type, sets: sets, date:date }
      trackEvent("PREMIUM-AI", "Wrong Answer Notes - Click " + jsUcfirst(type), "");
    }

    this.setState({
      displayedQuiz : quizTableData,
      selectedDiv   : event.currentTarget,
    });
  }

  render(){
    let {spinner, displayedQuiz, sound} = this.state;
    let handlers = {
      onAudioPlay: this.onAudioPlay.bind(this),
      onAudioEnd: this.onAudioEnd.bind(this)
    }

    return(
      <div>
        <div className={spinner?'visible':'hidden'} >
          <Spinner />
        </div>
        <WeekTable weeks={this.props.weeks} state={this.state}
         show={this.show.bind(this)} onClick={this.quizDayClicked.bind(this)} />
        <Row className="note_table_row text-left pro_row">
          <Col className="note_table" xs={12} md={10} mdOffset={1}>
            {displayedQuiz?
              <QuizTable data={displayedQuiz} userState={this.props.userState}
                sound={sound} handlers={handlers}/>
             : null
           }
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return{
    quizResult: state.pro.quizResult,
    weeks: state.dashboard.weeks,
    courseId: state.auth.courseId,
    userState: state.auth.userState
  };
};

const mapDispatchToProps = (dispatch) => {
  return{
    getQuizResult: (week, courseId) => {
      dispatch(getQuizResult(week, courseId));
    },
    getWeeks: (courseId)=>{
      dispatch(getWeeks(courseId));
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(WrongNotes);



// WEBPACK FOOTER //
// ./src/containers/Pro.WrongNote.js